module.exports = __webpack_public_path__ + "img/Alaska-301.dfea89ba.jpg";